<template>
  <div ref="fullAnim" class="fullAnim"></div>
  <div class="landscape-mode">

    <div id="main_contain">

      <div id="main_content">

        <MainHeader :index-data="indexData"/>
        <MainContent style="margin-top: 8.3rem;" :tab-data="tabData"/>
        <div v-if="$store.state.showLogin" class="dialog_contain">
          <LoginDialog @event="dismissLogin" :index-data="indexData"/>
        </div>
        <div v-if="taskDialog && !$store.state.showLogin" class="dialog_contain" @click.self="dismissTask">
          <NewTaskDialog :index-data="indexData" :task-data="taskData" />
        </div>
        <div v-if="levelDialog && !$store.state.showLogin && !taskDialog" class="dialog_contain" @click.self="dismissLevelDialog">
          <LevelDialog @event="dismissTask"/>
        </div>

        <div v-if="earnMoneyTips && dialogEntity && !$store.state.showLogin && !taskDialog"  class="dialog_contain" @click.self="dismissEarnTips">
          <EarnTipsDialog :earn="dialogEntity?.money" @event="dismissEarnTips"/>
        </div>

        <div v-if="upgradeEarnMoneyTips && !$store.state.showLogin && !taskDialog"  class="dialog_contain" @click.self="dismissUpgradeEarnTips">
          <EarnTipsDialog :earn="upgradeMoney" @event="dismissUpgradeEarnTips"/>
        </div>


        <div v-if="noticeTips && dialogEntity && !$store.state.showLogin && !taskDialog"  class="dialog_contain" @click.self="dismissNoticeTips">
          <NoticeDialog :tips="dialogEntity?.desc" :earn="dialogEntity?.money" @event="dismissNoticeTips"/>
        </div>

        <div v-if="levelUp && dialogEntity && !$store.state.showLogin && !taskDialog" class="dialog_contain" @click.self="dismissLevelUpTips">
          <LevelUpDialog :level="dialogEntity?.level" @event="dismissLevelUpTips"/>
        </div>

        <div v-if="openNextRound && !$store.state.showLogin" class="dialog_contain">
          <OpenNextRoundTaskDialog :data="nextRoundData" />
        </div>

        <!-- 提现提示：达到提现条件后引导去提现。带黑色遮罩，气泡指向右上角 Withdraw 按钮，5 秒自动消失。
             TODO: 触发时机待定 —— 目前没有任何地方 commit('withdrawTip', true)，条件确定后接上即可 -->
        <div v-if="$store.state.withdrawTip" class="dialog_contain" @click.self="dismissWithdrawTip">
          <div class="withdraw-tip" @click="dismissWithdrawTip">
            <span v-if="$store.state.withdrawTipEn">{{ $store.state.withdrawTipEn }}</span>
            <span v-else>You can withdraw <span class="wt-hl">your cash now</span></span>
          </div>
        </div>
      </div>

      <div class="pre_web">
          <iframe ref="iframe" :src="serviceurl"></iframe>
        </div>
    </div>
  </div>

</template>

<script>
import MainHeader from '@/components/main/MainHeader.vue'
import MainContent from '@/components/main/MainContent.vue'

import http from '@/utils/http'
import LoginDialog from '@/components/login/LoginDialog.vue'
import TaskDialog from '@/components/dialog/TaskDialog.vue'
import bus from 'vue3-eventbus'
import { mapState } from 'vuex'
import LevelDialog from '@/components/dialog/LevelDialog.vue'
import EarnTipsDialog from '../dialog/EarnTipsDialog.vue'
import LevelUpDialog from '../dialog/LevelUpDialog.vue'
import NoticeDialog from '../dialog/NoticeDialog.vue'

import NewTaskDialog from '../dialog/NewTaskDialog.vue'
import OpenNextRoundTaskDialog from '../dialog/OpenNextRoundTaskDialog.vue'

import lottie from 'lottie-web'

export default {
  components: {
    LevelDialog,
    TaskDialog,
    LoginDialog,
    MainHeader,
    MainContent,
    EarnTipsDialog,
    LevelUpDialog,
    NoticeDialog,
    NewTaskDialog,
    OpenNextRoundTaskDialog
  },
  data () {
    return {
      upgradeEarnMoneyTips: false,
      tabData: {},
      dialogEntity: {},
      upgradeMoney: null,
      indexData: '',
      taskData:'',
      serviceurl: '',
      taskDialog: false,
      levelDialog: false,
      levelUp:false,
      earnMoneyTips:false,
      earnMoneyStatus: false,
      noticeTips:false,
      openNextRound:false,
      nextRoundData:{},
      lottieAnim: null
    }
  },
  computed: {
    ...mapState(['pn', 'aid', 'pkg', 'uid', 'channel', 'code','gaid'])
  },
  watch: {
    // 提现提示出现后 5 秒自动消失
    '$store.state.withdrawTip' (val) {
      if (val) {
        if (this._withdrawTipTimer) {
          clearTimeout(this._withdrawTipTimer)
        }
        this._withdrawTipTimer = setTimeout(() => {
          this.$store.commit('withdrawTip', false)
        }, 5000)
      }
    }
  },
  beforeUnmount () {
    if (this._withdrawTipTimer) {
      clearTimeout(this._withdrawTipTimer)
    }
  },
  created () {
    // this.$store.commit('code', localStorage.getItem('code'), '')
    bus.on('main_task', (show) => {
      this.taskDialog = show
    })
    bus.on('login_action', () => {
      this.savedata('ios_token', this.$store.state.token)
      this.savedata('ios_code', this.$store.state.code)
      this.requestIndexData()
    })
    bus.on('refresh', () => {
      this.requestIndexData()
    })
    bus.on('taskAllClaim',(data) => {
      this.taskDialog = false
      this.nextRoundData = data
      if(this.indexData.taskRound == 2){
        this.setAnim(require(`@/assets/feibx2.json`),  () => {
          if(!data.allTaskClaimed){
            this.openNextRound = true
          }
          this.requestIndexData()
        })
      }else{
        this.setAnim(require(`@/assets/feibx1.json`),  () => {
          if(!data.allTaskClaimed){
            this.openNextRound = true
          }
          this.requestIndexData()
        })
      }

    })
    bus.on('showNextTask',(data) => {
      this.openNextRound = false
      this.taskDialog = true
    })
    bus.on('showLevelDialog', (show) => {
      try {
        this.levelDialog = show
      } catch (e) {
        console.log(e)
      }
    })
    bus.on('dismissEarnTips', () => {
      this.dismissEarnTips()
      this.dismissUpgradeEarnTips()
    })
    bus.on('dismissLevelUp', () => {
      this.dismissLevelUpTips()
    })
    bus.on('dismissNoticeTips', () => {
      this.dismissNoticeTips()
    })
  },
  methods: {

    dismissLogin () {
      this.showLogin = false
    },
    dismissWithdrawTip () {
      this.$store.commit('withdrawTip', false)
    },
    dismissTask () {
      this.taskDialog = false
      if(this.indexData.taskRound == 2){
        this.setAnim(require(`@/assets/feibx4.json`),  () => {
          this.requestIndexData()
        })
      }else{
        this.setAnim(require(`@/assets/feibx3.json`),  () => {
          this.requestIndexData()
        })
      }
    },
    dismissEarnTips() {
      this.earnMoneyTips = false
    },
    dismissUpgradeEarnTips() {
      this.upgradeEarnMoneyTips = false
    },
    dismissNoticeTips() {
      this.noticeTips = false
    },
    dismissLevelUpTips() {
      this.levelUp = false
    },
    dismissLevelDialog() {
      this.levelDialog = false
    },
    requestIndexData () {
      let region = 'US';
      http.getHttp(`/region/vgi/index?uid=${this.uid}&aid=${this.aid}&channelid=${this.channel}&pkg=${this.pkg}&pn=${this.pn}&region=${region}&gaid=${this.gaid}`)
        .then((resp) => {
          if (resp.code !== 0) {
            return
          }
          this.indexData = resp
          this.$store.commit('user', resp.data)
          this.$store.commit('finish_task_count', resp.finish_task_count)
          this.$store.commit('linkUrl', resp.data.url)
          this.$store.commit('mobile', resp.data.mobile)
          this.$store.commit('code', resp.data.code)
          if (resp.token) {
            this.$store.commit('token', resp.token)
          }
          this.$store.commit('indexData',resp)
          this.requestMenuData()
          this.requestShareData()

          this.requestDialogStrategy(!!resp.show_welcome)
          this.requestNewTaskData()

          // 接口没回 token 时再看本地：本次请求已带本地 token 且没走 401（过期会在 http 拦截器里
          // 清 token 并弹登录），说明本地 token 仍有效，不用强制登录
          if (resp.data.balance > 20 && !resp.token && !this.$store.state.token) {
            this.$store.commit('showLogin', true)
            this.$store.commit('forceLogin', true)
          } else {
            this.$store.commit('forceLogin', false)
          }
        })
    },

    requestNewTaskData () {
      const requestBody = {
        pn: this.pn,
        aid: this.aid,
        pkg: this.pkg,
        uid: this.uid,
        code: this.code,
        channel: this.channel,
        region: 'US',
        channelid:this.channel,
      }
      http.postHttp(`/landscape/region/taskV2/openOrCreateTask`,requestBody)
        .then((resp) => {
          if (resp.code !== 0) {
            return
          }


          this.taskData = resp

          this.$store.commit('taskData',resp)
        })
    },

    requestDialogStrategy(showWelcome){
      if(!showWelcome) {
        showWelcome = false
      }
      const requestBody = {
        showWelcome:showWelcome,
        pn: this.pn,
        aid: this.aid,
        pkg: this.pkg,
        uid: this.uid,
        code: this.code,
        channel: this.channel,
        region: 'US'
      }
      let region = 'US'
      http.getHttp(`/region/vgi/hint?uid=${this.uid}&aid=${this.aid}&region=${region}&lang=en&code=${this.code}&showWelcome=${showWelcome}`)
        .then((resp) => {
          var list = resp?.data?.list
          this.dialogEntity = list?.length > 0 ? list[0] : null
          if(this.dialogEntity){
            const type = this.dialogEntity.type

            switch (type) {
              case "0":
              case "1":
                this.earnMoneyTips = true
                break
              case "2":
              case "4":
              case "3":
                const match = this.dialogEntity.desc.match(/^(\$\S+)\s+(.*)$/);

                let amount = "";
                let message = this.dialogEntity.desc;

                if (match) {
                  amount = match[1];
                  message = match[2];
                  this.dialogEntity.desc = message
                  this.dialogEntity.money = amount
                }
                // a negative amount is a deduction; never announce it as credited
                const numericAmount = parseFloat(amount.replace(/[^\d.-]/g, ''))
                if (!Number.isNaN(numericAmount) && numericAmount < 0) {
                  this.dialogEntity = null
                  break;
                }
                this.noticeTips = true
                break;
              case "6":
                this.levelUp = true
                break;
            }
          }
        })
    },
    requestMenuData () {
      const requestBody = {
        pn: this.pn,
        aid: this.aid,
        pkg: this.pkg,
        uid: this.uid,
        code: this.code,
        channel: this.channel,
        region: 'US'
      }
      http.postHttp('/region/customizedcustommenu/queryMenuList', JSON.stringify(requestBody))
        .then((resp) => {
          this.tabData = resp
          this.$store.commit('tabData', resp)
        })
    },
    requestShareData () {
      const code = this.code
      const pn = this.pn
      http.getHttp('/landscape/promotion/distribute/a/' + code + '?pn=' + pn)
        .then((resp) => {
          if (resp.code !== 0) {
            return
          }
          this.$store.commit('shareData', resp.data)
        })
    },
    savedata (key, value) {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.savedata) {
        window.webkit.messageHandlers.savedata.postMessage({
          key: key,
          value: value
        })
      }
    },
    setAnim(anim,callback){
      if (this.lottieAnim) {
        this.lottieAnim.destroy()
        this.lottieAnim = null
      }
      this.lottieAnim = lottie.loadAnimation({
        container: this.$refs.fullAnim,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: anim
      })

      this.lottieAnim.addEventListener('complete', () => {
        console.log('动画播放结束')
          callback && callback()
          this.lottieAnim.destroy()
          this.lottieAnim = null
      })
      this.lottieAnim.play()
    }
  },
  mounted () {
    this.serviceurl = http.baseH5Url + '/customer_nova.html?channel=' + this.channel
    const tabData = this.$store.state.tabData
    if (tabData) {
      this.tabData = tabData
    }
    setTimeout(() => {
      this.requestIndexData()
    }, 200)

    window.addEventListener('message', (event) => {
      try {
        let data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

        if (data.action === 'share_upgrade_rewards') {
          this.upgradeMoney = data.amount
          this.upgradeEarnMoneyTips = true;
          this.requestIndexData();
        }
      } catch (e) {
        console.log('message e:', e)
      }
    })
  }

}

</script>
<style>
.dialog_contain {
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  left: 0;
  z-index: 50;
  top: 0;
  justify-content: center;
}

/* 提现气泡：整块用切图 bg_withdraw_popup.png（288x133，含紫色发光边和向上的尾巴）
   盒子按图片比例(2.165)设尺寸避免变形；上方留白给内置尾巴，文字居中在矩形区。
   位置让内置尾巴正对右上角 Withdraw 按钮 */
.withdraw-tip {
  position: absolute;
  top: 8.6rem;
  right: 4.5rem;
  width: 30rem;
  height: 13.86rem;
  box-sizing: border-box;
  background: url("@/assets/bg_withdraw_popup.png") center / 100% 100% no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 让文字居中在切图的矩形区(垂直中心≈54.5%)，顶部留白给向上尾巴 */
  padding: 1.76rem 3rem 0.5rem 3rem;
  color: #FFFFFF;
  font-size: 2.4rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
}
/* "your cash now" 高亮 */
.withdraw-tip .wt-hl {
  color: #FFE602;
}

@media screen and (orientation: portrait) {
  .landscape-mode {
    height: 100vw;
    width: 94vh;
    transform: rotate(90deg);
    transform-origin: 0 0;
    top: 0;
    left: 100%;
    position: absolute;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  #main_contain {
    width: 168vw;
    height: 94vw;
    display: flex;
    align-items: center;
    align-self: center;
    justify-items: center;
    align-content: center;
    justify-content: center;
  }

  #main_content {
    height: 100%;
    width: 100%;
    align-self: center;
    display: flex;
    flex-direction: column;
  }
}

@media screen and (orientation: landscape) {
  .landscape-mode {
    width: 100%;
    height: 100%;
  }
}
.pre_web{
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.fullAnim {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 99;
  pointer-events: none;
  margin-left: -15rem;
}
</style>
